/** @jsx jsx */

import { Colors } from '@zapier/theme';
import { LogoImage, SelectItemType } from '@zapier/common-components';
import { css, jsx } from '@emotion/core';

import AppBanner from '@zapier/services/esm/components/AppBanner';

type MenuItemComponentProps = {
  item: SelectItemType;
};

const getServiceItemStyles = (disabled?: boolean) =>
  css(
    {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
    },
    disabled && {
      opacity: 0.5,
      cursor: 'default',
    }
  );

const serviceBannerStyles = {
  marginLeft: 'auto',
};

const serviceDescriptionStyles = {
  display: 'flex',
  flexDirection: 'column' as 'column',
  justifyContent: 'center',
  marginLeft: '10px',
};

const serviceInfoStyles = {
  display: 'flex',
  flexDirection: 'row' as 'row',
};

const serviceNameStyles = {
  fontSize: '14px',
  color: Colors.theme.secondary.text,
};

/** Renders a single service item in the dropdown. */
const MenuItemComponent = ({ item }: MenuItemComponentProps) => (
  <div css={getServiceItemStyles(item.isDisabled)}>
    <div css={serviceInfoStyles}>
      <LogoImage app={item.key} size={32} />
      <div css={serviceDescriptionStyles}>
        <div css={serviceNameStyles}>{item.name}</div>
        <div>{item.subtitle}</div>
      </div>
    </div>
    <div css={serviceBannerStyles}>
      <AppBanner banner={item.banner} />
    </div>
  </div>
);

export default MenuItemComponent;
